import DashboardLayout from '@/views/Layout/DashboardLayout.vue';

const DeliveryNotesList = () => import(/* webpackChunkName: "delivery_notes" */ '@/views/DeliveryNotes/List.vue');
const DeliveryNoteCreate = () => import(/* webpackChunkName: "delivery_notes" */ '@/views/DeliveryNotes/Create.vue');

let deliveryNotesPages = {
  path: '/delivery-notes',
  redirect: '/delivery-notes',
  component: DashboardLayout,
  name: 'DeliveryNotes',
  meta: {
    title: 'Remitos',
    auth: true,
  },
  children: [
    {
      path: '',
      name: 'DeliveryNotesList',
      meta: {
        title: 'Listado',
        auth: ['delivery_notes.index'],
      },
      component: DeliveryNotesList,
    },
    {
      path: 'create',
      name: 'DeliveryNoteCreate',
      meta: {
        title: 'Nuevo',
        auth: ['delivery_notes.store'],
      },
      component: DeliveryNoteCreate,
    },
  ],
};

export default deliveryNotesPages;
